@import "./sellalong-help-modal.css";

.sellalong-help-modal-heading {
  text-transform: uppercase;
  letter-spacing: 4.4px;
  font-size: 22px;
  line-height: 1.6em;
}

.sellalong-help-modal-icon-wrapper {
  background: #fff;
}

.sellalong-help-modal p {
  font-family: var(--sellalong-text-font, serif);
}

.sellalong-help-modal .sellalong-help-modal-close-button {
  color: var(--sellalong-colour-primary, #000);
}

.sellalong-help-modal-steps h4 {
  text-transform: uppercase;
  letter-spacing: 2.8px;
  font-size: 14px;
  min-height: 4em;
}

@media screen and (max-width: 600px) {
  .sellalong-help-modal-steps h4 {
    min-height: 6em;
  }
}
